/* ============================================================
   bedCheats — Shopify theme logic (vanilla, no build)
   Ported from the Claude Design prototype (site.js) and adapted:
   real AJAX cart, variant selection, Shopify forms.
   ============================================================ */
(function () {
  'use strict';
  var theme = window.theme || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var FAV_KEY = 'bc_favs_v1';

  function lucide() { if (window.lucide) window.lucide.createIcons({ nameAttr: 'data-lucide' }); }

  /* ---------------- money ---------------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || theme.moneyFormat || '${{amount}}';
    var out = '';
    var ph = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cts = parts[1] ? decimal + parts[1] : '';
      return dollars + cts;
    }
    var match = format.match(ph);
    switch (match ? match[1] : 'amount') {
      case 'amount': out = fmt(cents, 2); break;
      case 'amount_no_decimals': out = fmt(cents, 0); break;
      case 'amount_with_comma_separator': out = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': out = fmt(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': out = fmt(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': out = fmt(cents, 2, "'", '.'); break;
      default: out = fmt(cents, 2);
    }
    return format.replace(ph, out);
  }

  /* ---------------- toast ---------------- */
  var toastT;
  function toast(msg) {
    var t = $('#toast'); if (!t) return;
    t.querySelector('span').textContent = msg; t.classList.add('show');
    clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('show'); }, 2400);
  }

  /* ---------------- cart drawer ---------------- */
  function openCart() {
    var s = $('#cart-scrim'), d = $('#cart-drawer');
    if (s) s.classList.add('open');
    if (d) { d.classList.add('open'); d.setAttribute('aria-hidden', 'false'); }
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    var s = $('#cart-scrim'), d = $('#cart-drawer');
    if (s) s.classList.remove('open');
    if (d) { d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); }
    document.body.style.overflow = '';
  }

  function itemHTML(it) {
    var media = it.image
      ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_x160$1$2') + '" alt="' + esc(it.product_title) + '">'
      : '<img src="' + (theme.assets && theme.assets.monogramNavy) + '" alt="" style="width:30px;height:auto;opacity:.5">';
    var opt = (it.variant_title && it.variant_title !== 'Default Title') ? '<p class="opt">' + esc(it.variant_title) + '</p>' : '';
    return '<div class="litem" data-key="' + it.key + '">' +
      '<div class="th">' + media + '</div>' +
      '<div class="li-b">' +
        '<h3 class="nm">' + esc(it.product_title) + '</h3>' + opt +
        '<div class="li-foot">' +
          '<div class="stepper">' +
            '<button type="button" data-q="-1" data-k="' + it.key + '" aria-label="Decrease quantity">−</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-q="1" data-k="' + it.key + '" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<span class="price">' + formatMoney(it.final_line_price) + '</span>' +
        '</div>' +
        '<button type="button" class="li-rm" data-rm="' + it.key + '">' + (str('remove') || 'Remove') + '</button>' +
      '</div>' +
    '</div>';
  }
  function emptyHTML() {
    return '<div class="empty"><img src="' + (theme.assets && theme.assets.motif) + '" alt="">' +
      '<p>' + (str('emptyBag') || 'Your bag is empty.') + '<br>Time to cheat your way to better sleep.</p>' +
      '<a class="btn btn-dark" href="/collections/all">Start Shopping</a></div>';
  }
  function str(k) { return theme.strings && theme.strings[k]; }
  function esc(s) { return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function renderCart(cart) {
    $$('.cc').forEach(function (el) { el.textContent = cart.item_count; el.style.display = cart.item_count ? '' : 'none'; });
    var items = $('#cart-items'), foot = $('#cart-foot');
    if (!items) return;
    if (!cart.item_count) {
      items.innerHTML = emptyHTML();
      if (foot) foot.style.display = 'none';
    } else {
      items.innerHTML = cart.items.map(itemHTML).join('');
      if (foot) foot.style.display = '';
      var sub = $('#cart-sub'); if (sub) sub.textContent = formatMoney(cart.total_price);
      wireCartButtons();
    }
    lucide();
  }
  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function cartChange(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }
  function addToCart(variantId, qty, name) {
    if (!variantId) return;
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res && res.status) { toast(res.description || res.message || 'Could not add to bag'); return; }
      return getCart().then(function (cart) {
        renderCart(cart); openCart();
        toast((name ? name + ' ' : '') + (str('addedToBag') || 'added to bag'));
      });
    }).catch(function () { toast('Something went wrong — please try again'); });
  }
  function wireCartButtons() {
    $$('#cart-items [data-q]').forEach(function (b) {
      b.onclick = function () {
        var li = b.closest('.litem'); var cur = parseInt(li.querySelector('.stepper span').textContent, 10) || 1;
        cartChange(b.dataset.k, Math.max(0, cur + parseInt(b.dataset.q, 10)));
      };
    });
    $$('#cart-items [data-rm]').forEach(function (b) { b.onclick = function () { cartChange(b.dataset.rm, 0); }; });
  }

  /* ---------------- favourites (visual, localStorage) ---------------- */
  function loadFavs() { try { return JSON.parse(localStorage.getItem(FAV_KEY)) || []; } catch (e) { return []; } }
  function saveFavs(v) { try { localStorage.setItem(FAV_KEY, JSON.stringify(v)); } catch (e) {} }
  var favs = loadFavs();
  function isFav(id) { return favs.indexOf(id) !== -1; }
  function toggleFav(id) { favs = isFav(id) ? favs.filter(function (x) { return x !== id; }) : favs.concat([id]); saveFavs(favs); }
  function initFavs() {
    $$('[data-fav]').forEach(function (b) {
      var id = b.dataset.fav;
      b.classList.toggle('on', isFav(id));
      b.setAttribute('aria-pressed', isFav(id));
      b.onclick = function (e) { e.preventDefault(); e.stopPropagation(); toggleFav(id); b.classList.toggle('on', isFav(id)); b.setAttribute('aria-pressed', isFav(id)); };
    });
  }

  /* ---------------- product cards: quick add ---------------- */
  function initQuickAdd(root) {
    $$('[data-add]', root || document).forEach(function (b) {
      b.onclick = function (e) {
        e.preventDefault(); e.stopPropagation();
        addToCart(b.getAttribute('data-variant-id'), 1, b.getAttribute('data-name'));
      };
    });
  }

  /* ---------------- header / nav ---------------- */
  function initHeader() {
    $$('[data-cart-open]').forEach(function (b) { b.onclick = function () { getCart().then(renderCart).finally(openCart); }; });
    var scrim = $('#cart-scrim'), close = $('#cart-close');
    if (scrim) scrim.onclick = closeCart;
    if (close) close.onclick = closeCart;
    var mnav = $('#mnav');
    $$('[data-mnav-open]').forEach(function (b) { b.onclick = function () { if (mnav) { mnav.classList.add('open'); document.body.style.overflow = 'hidden'; } }; });
    function closeMnav() { if (mnav) mnav.classList.remove('open'); document.body.style.overflow = ''; }
    var mclose = $('#mnav-close'); if (mclose) mclose.onclick = closeMnav;
    if (mnav) { var ms = mnav.querySelector('.scrim'); if (ms) ms.onclick = closeMnav; }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); closeMnav(); } });
  }

  /* ---------------- HOME: hero slideshow + testimonials ---------------- */
  function initHome() {
    var slides = $$('.hero-split .slide');
    function loadSlide(s) { if (s && !s.getAttribute('src') && s.getAttribute('data-src')) { s.src = s.getAttribute('data-src'); } }
    if (slides.length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setTimeout(function () { loadSlide(slides[1]); }, 1200);
      var si = 0;
      setInterval(function () {
        slides[si].classList.remove('on');
        si = (si + 1) % slides.length;
        loadSlide(slides[si]); loadSlide(slides[(si + 1) % slides.length]);
        slides[si].classList.add('on');
      }, 4200);
    }
    var tq = $('#tquote');
    if (tq) {
      var data = [];
      var dataEl = $('#tquote-data', tq);
      try { data = JSON.parse(dataEl.textContent); } catch (e) { data = []; }
      if (data.length) {
        var qin = $('.qin', tq), dots = $('.tdots', tq), ti = 0, auto;
        dots.innerHTML = data.map(function (_, i) { return '<button class="tdot ' + (i === 0 ? 'on' : '') + '" aria-label="Testimonial ' + (i + 1) + '"></button>'; }).join('');
        var dotEls = $$('.tdot', tq);
        function show(i) {
          ti = i;
          qin.innerHTML = '<span class="script">' + esc(data[i].eyebrow) + '</span>' +
            '<blockquote>“' + esc(data[i].quote.toUpperCase()) + '”</blockquote>' +
            '<div class="who">' + esc(data[i].who) + ' · ★★★★★</div>';
          dotEls.forEach(function (d, k) { d.classList.toggle('on', k === i); });
        }
        dotEls.forEach(function (d, i) { d.onclick = function () { show(i); }; });
        show(0);
        function play() { auto = setInterval(function () { show((ti + 1) % data.length); }, 6000); }
        play();
        tq.addEventListener('mouseenter', function () { clearInterval(auto); });
        tq.addEventListener('mouseleave', play);
      }
    }
  }

  /* ---------------- PRODUCT (PDP): variant selection ---------------- */
  function initPDP() {
    var root = $('#pdp'); if (!root) return;
    var data;
    var dataEl = $('#pdp-data', root) || $('#pdp-data');
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var variants = data.variants || [];
    var selected = {}; // optionPosition -> value
    // seed from first available variant
    var first = variants.filter(function (v) { return v.available; })[0] || variants[0];
    if (first) (data.options || []).forEach(function (o, idx) { selected[idx + 1] = first['option' + (idx + 1)]; });

    function findVariant() {
      return variants.find(function (v) {
        return (data.options || []).every(function (o, idx) { return v['option' + (idx + 1)] === selected[idx + 1]; });
      });
    }
    function update() {
      var v = findVariant();
      var addBtn = $('#pdp-add'), idInput = $('#pdp-variant-id'), priceEl = $('#pdp-price'), saveEl = $('#pdp-save');
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.querySelector('span').textContent = str('unavailable') || 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = formatMoney(v.price) + (v.compare_at_price > v.price ? '<s>' + formatMoney(v.compare_at_price) + '</s>' : '');
      if (saveEl) saveEl.style.display = (v.compare_at_price > v.price) ? '' : 'none';
      if (saveEl && v.compare_at_price > v.price) saveEl.textContent = 'Save ' + formatMoney(v.compare_at_price - v.price);
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.querySelector('span').textContent = v.available
          ? (data.addLabel || 'Add to Bag') + ' — ' + formatMoney(v.price)
          : (str('soldOut') || 'Sold out');
      }
    }
    // wire option controls (pills + swatches share [data-opt]/[data-val])
    $$('[data-opt]', root).forEach(function (btn) {
      btn.onclick = function () {
        var pos = parseInt(btn.getAttribute('data-opt'), 10);
        selected[pos] = btn.getAttribute('data-val');
        $$('[data-opt="' + pos + '"]', root).forEach(function (x) { x.classList.toggle('on', x === btn); });
        var nameEl = $('#opt-name-' + pos, root); if (nameEl) nameEl.textContent = btn.getAttribute('data-val');
        update();
      };
    });
    // gallery thumbs
    $$('.thumb', root).forEach(function (b) {
      b.onclick = function () {
        $$('.thumb', root).forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
        var main = $('#gmain-img', root); var src = b.getAttribute('data-img');
        if (main && src) main.src = src;
      };
    });
    var form = $('#pdp-form');
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = findVariant(); if (!v || !v.available) return;
      addToCart(v.id, 1, data.title);
    });
    var favBtn = $('#pdp-fav');
    if (favBtn) {
      var id = data.handle;
      var on = isFav(id); favBtn.classList.toggle('on', on);
      favBtn.onclick = function () { toggleFav(id); var o = isFav(id); favBtn.classList.toggle('on', o); favBtn.classList.toggle('btn-primary', o); favBtn.classList.toggle('btn-outline', !o); favBtn.setAttribute('aria-pressed', o); };
    }
    update();
  }

  /* ---------------- SHOP filters: sort ---------------- */
  function initShop() {
    var sortSel = $('#shop-sort');
    if (sortSel) sortSel.onchange = function () {
      var url = new URL(location.href);
      url.searchParams.set('sort_by', sortSel.value);
      location.href = url.toString();
    };
  }

  /* ---------------- CONTACT form + FAQ ---------------- */
  function initContact() {
    var form = $('#contact-form');
    if (form) {
      var fields = $$('[data-validate]', form);
      function validate(f) {
        var v = (f.value || '').trim(), ok = true;
        if (f.hasAttribute('required') && !v) ok = false;
        if (f.type === 'email' && v && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)) ok = false;
        f.classList.toggle('invalid', !ok);
        var e = f.parentElement.querySelector('.err'); if (e) e.classList.toggle('show', !ok);
        return ok;
      }
      fields.forEach(function (f) { f.addEventListener('blur', function () { validate(f); }); });
      form.addEventListener('submit', function (e) {
        var ok = true; fields.forEach(function (f) { if (!validate(f)) ok = false; });
        if (!ok) e.preventDefault();
      });
    }
    $$('.qa .q').forEach(function (q) {
      q.onclick = function () {
        var qa = q.closest('.qa'); var open = qa.classList.contains('open'); var a = qa.querySelector('.a');
        if (open) { qa.classList.remove('open'); a.style.maxHeight = 0; q.setAttribute('aria-expanded', 'false'); }
        else { qa.classList.add('open'); a.style.maxHeight = a.scrollHeight + 'px'; q.setAttribute('aria-expanded', 'true'); }
      };
    });
  }

  /* ---------------- boot ---------------- */
  function boot() {
    initHeader();
    initHome();
    initShop();
    initPDP();
    initContact();
    initFavs();
    initQuickAdd();
    lucide();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
